import { fetchApp } from "../../../services/apiService";
export type ApiRequestLog = {
  id: string;

  ip_address?: string | null;

  requester_id?: string | null;
  requester_type?: string | null;
  requester_name?: string | null;
  requester_email?: string | null;
  requester_phone?: string | null;

  client_id?: string | null;
  customer_id?: string | null;
  reseller_partner_id?: string | null;

  method: string;
  path: string;
  query_params?: string | null;

  status_code: number;
  duration_ms: number;

  device_id?: string | null;
  device_type?: string | null;
  device_os?: string | null;
  browser?: string | null;
  user_agent?: string | null;

  referer?: string | null;
  error_message?: string | null;
  auth_error?: string | null;

  created_at?: string | null;
};

export type ApiLogsSummary = {
  total_logs: number;
  success_logs: number;
  failed_logs: number;
  customer_logs: number;
  technician_logs: number;
  reseller_logs: number;
  user_logs: number;
};

export type ApiLogsResponse = {
  items: ApiRequestLog[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
  summary: ApiLogsSummary;
};

export type ApiLogsFilters = {
  page?: number;
  page_size?: number;
  requester_type?: string;
  status_code?: string;
  method?: string;
  search?: string;
};

export async function getApiLogs(filters: ApiLogsFilters = {}) {
  const params = new URLSearchParams();

  params.set("page", String(filters.page || 1));
  params.set("page_size", String(filters.page_size || 20));

  if (filters.requester_type) {
    params.set("requester_type", filters.requester_type);
  }

  if (filters.status_code) {
    params.set("status_code", filters.status_code);
  }

  if (filters.method) {
    params.set("method", filters.method);
  }

  if (filters.search) {
    params.set("search", filters.search);
  }

  return fetchApp<ApiLogsResponse>(`/api-logs/?${params.toString()}`);
}
